import { InputGroup } from "@smartsuite/react-ui/lib";
import * as yup from "yup";
import { FormFieldControl } from "../../../../components/FormFieldControl/FormFieldControl";
import { useFormField } from "../../../../hooks/useFormField";
import { FormFieldProps } from "../../../types";
import { applyYupDefaults, validateWithYup } from "../../../validator";
import { TextareaFieldValue } from "../textarea.config";
import { CustomScrollbarTextarea } from "@smartsuite/react-ui/lib/components/forms/CustomScrollbarTextarea";
import { TextAccelerator } from "../../../../components/TextAccelerator/TextAccelerator";
import { validatorText } from "../../../validator.text";
import { $t } from "../../../../utils/intl";

import "./TextAreaFieldControl.sass";

export type TextAreaFieldControlProps = FormFieldProps;

const DEFAULT_MAX_LENGTH = 120000;

export const TextAreaFieldControl: React.FunctionComponent<TextAreaFieldControlProps> = ({
  field,
  formItem,
  name,
  label,
  required,
  placeholder,
  caption,
  readOnly,
}) => {
  const maxLength = field.params.max_length;

  const formField = useFormField<TextareaFieldValue>({
    name,
    validate: validateWithYup(
      applyYupDefaults(
        yup
          .string()
          .max(
            maxLength ?? DEFAULT_MAX_LENGTH,
            $t(validatorText.validationMaxLength, { maxLength })
          ),
        field,
        formItem
      )
    ),
  });

  return (
    <FormFieldControl
      captionAsTooltip={formItem.params.help_text_as_tooltip}
      label={label}
      caption={caption}
      helpText={formItem.params.helpText}
      required={required}
      state={formField.state}
      errorMessage={formField.errorMessage}
      readOnly={readOnly}
    >
      <InputGroup state={formField.state} inputBackground="white-new">
        <CustomScrollbarTextarea
          className="form-textarea-field"
          changeHeightWhenTyping
          minHeight={78}
          maxHeight={400}
          readOnly={readOnly}
          name={formField.name}
          value={formField.value}
          required={required}
          maxLength={maxLength ?? DEFAULT_MAX_LENGTH}
          placeholder={placeholder}
          onChange={formField.onChange}
          onBlur={formField.onBlur}
          onFocus={formField.onFocus}
        />
      </InputGroup>
      <TextAccelerator maxLength={maxLength} length={formField.value?.length ?? 0} />
    </FormFieldControl>
  );
};
